import { render, staticRenderFns } from "./Directors.vue?vue&type=template&id=64a1e398&scoped=true"
import script from "./Directors.vue?vue&type=script&lang=js"
export * from "./Directors.vue?vue&type=script&lang=js"
import style0 from "./Directors.vue?vue&type=style&index=0&id=64a1e398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1e398",
  null
  
)

export default component.exports